export default __webpack_public_path__ + "static/media/ViewImaging.e618a77d.svg";